import type { Styles } from 'src/theme/themes';

export const styles = {
  orgTreeSearch: {
    maxHeight: (theme) => theme.spacing(30),
    height: '100%',
    marginBottom: '16px',
    display: 'flex',
  },
  popup: {
    backgroundColor: (theme) => theme.colors.white,
    width: '100%',
    height: '100%',
    overflow: 'auto',
  },
  popupHidden: {
    display: 'none',
  },
  loadingIndicator: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
  },
} satisfies Styles;
